export function TaxCertificate() {
  return (
    <div>
      <h2 className='font-mitr text-[24px] ladding-[1.5] font-medium text-secondary dark:text-dark-10'>
        หนังสือรับรองการหักภาษี ณ ที่จ่าย
      </h2>
      <a
        className='text-primary text-[14px] underline cursor-pointer'
        href='/withholding-tax'
        target='_blank'
      >
        ขั้นตอนการดาวน์โหลดใบหักภาษี ณ ที่จ่าย จากกรมสรรพากร
      </a>
    </div>
  )
}
